import { Injectable } from '@angular/core';

import { OverlayServiceBase, TiimeOverlayConfig } from 'tiime-material';

import { SearchOverlayComponent } from './search-overlay.component';

@Injectable({
  providedIn: 'root'
})
export class SearchOverlayService extends OverlayServiceBase<void, null> {
  open(config: TiimeOverlayConfig | undefined): this {
    this.overlayRef = this.overlayService.open(SearchOverlayComponent, null, {
      disposeOnNavigation: true,
      width: '460px',
      height: '287px',
      maxHeight: '287px',
      hasBackdrop: true,
      backdropClose: true,
      ...config
    });
    return this;
  }

  close(): void {
    if (this.overlayRef) {
      this.overlayRef.close(null);
    }
  }
}
